import { api } from "../common/http";
const toPage = (res) => res.data;

const AgentBalancesApi = {
    list: async ({ page = 0, size = 500, sort = "agentId,asc", q, country } = {}) => {
    const params = { page, size, sort };
    if (q) params.q = q;
    if (country) params.country = country;
    const res = await api.get("/agent-balances", { params });
    return toPage(res);
  },
  getSnapshot: async ({ agentId, country, currency }) => {
    const params = { agentId, country, currency };
    return (await api.get("/agent-balances/snapshot", { params })).data;
  },

  fund: async ({ agentId, country, currency, amount }) =>
    (await api.post("/agent-balances/fund", { agentId, country, currency, amount })).data,

  agentReturn: async ({ agentId, country, currency, amount, reason }) =>
    (await api.post("/agent-balances/return", { agentId, country, currency, amount, reason })).data,

  reserve: async ({ agentId, country, currency, amount, txUuid }) =>
    (await api.post("/agent-balances/reserve", { agentId, country, currency, amount, txUuid })).data,

  release: async ({ agentId, country, currency, amount, txUuid }) =>
    (await api.post("/agent-balances/release", { agentId, country, currency, amount, txUuid })).data,

  payout: async ({ agentId, country, currency, amount, txUuid }) =>
    (await api.post("/agent-balances/payout", { agentId, country, currency, amount, txUuid })).data,

  refund: async ({ agentId, country, currency, amount, reason }) =>
    (await api.post("/agent-balances/refund", { agentId, country, currency, amount, reason })).data,

  fee: async ({ agentId, country, currency, amount, reason }) =>
    (await api.post("/agent-balances/fee", { agentId, country, currency, amount, reason })).data,

  transfer: async ({ fromAgentId, toAgentId, country, currency, amount }) =>
    (await api.post("/agent-balances/transfer", { fromAgentId, toAgentId, country, currency, amount })).data,
};

export default AgentBalancesApi;
